import { createSlice } from '@reduxjs/toolkit';

const profileDataSlice = createSlice({
    name: 'profileData',
    initialState: {
        isLoading: false,

        profile: null,
        company: null,
        address: null,
        education: null,
        experience: null,
        documents: null,
        bankAccount: null,

        error: null,
        loaderMessage: ''
    },

    reducers: {
        // -------- PROFILE (with company) --------
        startFetchProfile: (state) => {
            state.isLoading = true;
            state.loaderMessage = 'Loading profile...';
            state.error = null;
        },
        setProfileData: (state, action) => {
            state.isLoading = false;
            state.profile = action.payload.profile || null;
            state.company = action.payload.company || null;
        },

        // -------- ADDRESS --------
        startFetchAddress: (state) => {
            state.loaderMessage = 'Loading address...';
        },
        setAddressData: (state, action) => {
            state.address = action.payload || null;
        },

        // -------- EDUCATION --------
        startFetchEducation: (state) => {
            state.loaderMessage = 'Loading education...';
        },
        setEducationData: (state, action) => {
            state.education = action.payload || null;
        },

        // -------- EXPERIENCE --------
        startFetchExperience: (state) => {
            state.loaderMessage = 'Loading experience...';
        },
        setExperienceData: (state, action) => {
            state.experience = action.payload || null;
        },

        // -------- DOCUMENTS --------
        startFetchDocuments: (state) => {
            state.loaderMessage = 'Loading documents...';
        },
        setDocumentsData: (state, action) => {
            state.documents = action.payload || null;
        },

        // -------- BANK ACCOUNT --------
        startFetchBankAccount: (state) => {
            state.loaderMessage = 'Loading bank account...';
        },
        setBankAccountData: (state, action) => {
            state.bankAccount = action.payload || null;
        },

        // -------- ERROR --------
        setProfileError: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },

        // -------- CLEAR ALL --------
        clearProfileData: (state) => {
            state.profile = null;
            state.company = null;
            state.address = null;
            state.education = null;
            state.experience = null;
            state.documents = null;
            state.bankAccount = null;
            state.error = null;
        }
    }
});

// Export all actions
export const {
    startFetchProfile,
    setProfileData,

    startFetchAddress,
    setAddressData,

    startFetchEducation,
    setEducationData,

    startFetchExperience,
    setExperienceData,

    startFetchDocuments,
    setDocumentsData,

    startFetchBankAccount,
    setBankAccountData,

    setProfileError,
    clearProfileData
} = profileDataSlice.actions;

export default profileDataSlice.reducer;

// Selectors
export const profileSelector = (state) => state.ProfileData.profile;
export const companySelector = (state) => state.ProfileData.company;

export const addressSelector = (state) => state.ProfileData.address;
export const educationSelector = (state) => state.ProfileData.education;
export const experienceSelector = (state) => state.ProfileData.experience;
export const documentsSelector = (state) => state.ProfileData.documents;
export const bankAccountSelector = (state) => state.ProfileData.bankAccount;

export const isLoadingProfileSelector = (state) => state.ProfileData.isLoading;
export const profileErrorSelector = (state) => state.ProfileData.error;
